import { FilterChip } from "../FilterChip";
import { FilterRange } from "./types";
import { RangeFilter } from "./RangeFilter";
import { buildRangeLabel } from "./utils";
import { useRangeFilter } from "./hooks/useRangeFilter";

interface RevenueRangeFilterChipProps {
  range: FilterRange;
  handleRangeChange: (min: number | undefined, max: number | undefined) => void;
  highlighted?: boolean;
  id?: string;
}

export const RevenueRangeFilterChip = ({
  range,
  handleRangeChange: onChange,
  highlighted,
  id = "revenue-range",
}: RevenueRangeFilterChipProps) => {
  const { range: revenueRange, handleRangeChange } = useRangeFilter({
    initialRange: range,
    hasFixedValue: false,
    onRangeChange: (newRange) => onChange(newRange.min, newRange.max),
  });

  return (
    <FilterChip
      id={id}
      label="Revenue Range"
      getSelectedCount={() => 0}
      renderLabel={() => buildRangeLabel(range)}
      popoverOptions={{ disableActionButtons: true }}
      onDelete={() => {
        onChange(undefined, undefined);
      }}
      addTitleClearButton={true}
      highlighted={highlighted}
    >
      <RangeFilter
        updatedOnType={true}
        value={revenueRange}
        onChange={(min, max) => handleRangeChange({ min, max })}
        prefix="$"
      />
    </FilterChip>
  );
};
